import React from 'react';
import { useController, Control, FieldValues, Path } from 'react-hook-form';

interface RHFInputCheckboxProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  label: string;
  disabled?: boolean;
  className?: string;
}

export function RHFInputCheckbox<T extends FieldValues>({
  name, control, label, disabled, className
}: RHFInputCheckboxProps<T>) {
  const { field, fieldState } = useController({ name, control });

  return (
    <div className={`fv-row mb-5 ${className || ''}`}>
      <div className="form-check form-check-custom form-check-solid">
        <input
          className="form-check-input"
          type="checkbox"
          disabled={disabled}
          checked={!!field.value}
          onChange={(e) => field.onChange(e.target.checked)}
          onBlur={field.onBlur}
          ref={field.ref}
        />
        <label className="form-check-label">{label}</label>
      </div>
      {fieldState.error && (
        <div className="fv-plugins-message-container invalid-feedback d-block">
          {fieldState.error.message}
        </div>
      )}
    </div>
  );
}
